const $ = jQuery;

export default class RetailersRoute {
  constructor() {
    this.addEvents();
    this.modifyDOM();
  }

  addEvents() {
  }

  modifyDOM() {
    /*
    * Initialize simplegmaps
    */
    $('#retailerMap').simplegmaps({
        MapOptions: {
            scrollwheel: false,
            panControl: false,
            styles: [{"featureType":"landscape","stylers":[{"hue":"#F1FF00"},{"saturation":-27.4},{"lightness":9.4},{"gamma":1}]},{"featureType":"road.highway","stylers":[{"hue":"#0099FF"},{"saturation":-20},{"lightness":36.4},{"gamma":1}]},{"featureType":"road.arterial","stylers":[{"hue":"#00FF4F"},{"saturation":0},{"lightness":0},{"gamma":1}]},{"featureType":"road.local","stylers":[{"hue":"#FFB300"},{"saturation":-38},{"lightness":11.2},{"gamma":1}]},{"featureType":"water","stylers":[{"hue":"#00B6FF"},{"saturation":4.2},{"lightness":-63.4},{"gamma":1}]},{"featureType":"poi","stylers":[{"hue":"#9FFF00"},{"saturation":0},{"lightness":0},{"gamma":1}]}],
        }
    });
    
    /*
    * Initialize mixitup
    */
    $('#retailerItems').mixItUp();
    
    $('#retailerFilter .filterSelect select').on('change', function(){
        $('#retailerItems').mixItUp('filter', this.value);
    });
    
    /*
    * MatchHeight
    */
    $('#retailerItems .item .inner').matchHeight();
  }
}
